import apiService from "./apiService";
import {appendUtcTimeZone} from "../../../helpers/helperFunctions";
import {PRODUCT_LIST_TYPE} from "../../../constants/commons";

const ITEM_PER_PAGE = 10;
const searchURL = process.env.REACT_APP_SEARCH_URL
export const getSpecialList = (page = 1, isHot = true, itemPerPage = ITEM_PER_PAGE) => {
  const params = {
    page: page,
    item_per_page: itemPerPage
  };
  return apiService.get(isHot ? URIS.hot_sales : URIS.fresh_sales, {params});
};

export const getFeaturedList = (page = 1, itemPerPage = ITEM_PER_PAGE) => {
  const params = {
    page: page,
    item_per_page: itemPerPage
  };
  return apiService.get(URIS.featured, {params});
}

export const getProductList = ({ page = 1, type, itemPerPage = ITEM_PER_PAGE, value, filterBy, skipFilter = true }) => {
  return type === PRODUCT_LIST_TYPE.hot ? getSpecialList(page, true, itemPerPage) :
    type === PRODUCT_LIST_TYPE.fresh ? getSpecialList(page, false, itemPerPage) :
      type === PRODUCT_LIST_TYPE.SEARCH ? getProductsBySearchKeyword({
          page: page,
          keyword: value,
          itemPerPage: itemPerPage,
          filterBy,
          skipFilter,
        }) :
        type === PRODUCT_LIST_TYPE.BRAND ? getProductListByBrand({
            page: page,
            brandId: value,
            itemPerPage: itemPerPage,
            filterBy,
            skipFilter,
          }) :
          type === PRODUCT_LIST_TYPE.CATEGORY ? getProductListByCategory({
              page: page,
              categoryId: value,
              itemPerPage: itemPerPage,

              filterBy,
              skipFilter,
            }) :
            type === PRODUCT_LIST_TYPE.PRODUCT_CAMPAIGN ? getCampaignProducts({
                page: page,
                campaignId: value,
                itemPerPage: itemPerPage,
                filterBy,
                skipFilter,
              }) :
              {}
}

export const getCampaignProducts = ({campaignId, page = 1, itemPerPage = ITEM_PER_PAGE, filterBy, skipFilter=true}) => {
  const params = {
    page: page,
    item_per_page: itemPerPage,
    ...(skipFilter && {
      filter: false,
    }),
  }
  // if (filterBy?.length) {
  //   filterBy.forEach((f) => {
  //     Object.assign(params, { [f.type]: f.values.join(',') })
  //   })
  // }
  Object.keys(filterBy).forEach(key => {
    const value = filterBy[key]
    Object.assign(params, { [key]: value })
  })

  return apiService.get(URIS_D("product_campaign", campaignId), {params});
};


export const getProductListByBrand = ({
                                        page = 1, brandId, itemPerPage = ITEM_PER_PAGE, filterBy,
                                        skipFilter = true,
                                      }) => {
  const params = {
    page: page,
    item_per_page: itemPerPage,
    brand_id: brandId,
    ...(skipFilter && {
      filter: false,
    }),
  }

  // if (filterBy?.length) {
  //   filterBy.forEach((f) => {
  //     Object.assign(params, { [f.type]: f.values.join(',') })
  //   })
  // }
  Object.keys(filterBy).forEach(key => {
    const value = filterBy[key]
    Object.assign(params, { [key]: value })
  })
  return apiService.get(URIS.products, { params })
}


export const getProductListByCategory = ({
                                           page = 1, categoryId, itemPerPage = ITEM_PER_PAGE,
                                           sortBy,
                                           filterBy,
                                           skipFilter = false,
                                         }) => {
  const params = {
    page: page,
    item_per_page: itemPerPage,
    ...(sortBy && { sort_by: sortBy }),
    ...(skipFilter && {
      filter: false,
    }),
  }

  // if (filterBy?.length) {
  //   filterBy.forEach((f) => {
  //     Object.assign(params, { [f.type]: f.values.join(',') })
  //   })
  // }

  Object.keys(filterBy).forEach(key => {
    const value = filterBy[key]
    Object.assign(params, { [key]: value })
  })


  return apiService.get(URIS_D('category_products', categoryId), { params })
}

export const getFlashSale = async () => {
  const {data} = await apiService.get(URIS.flash_sales);
  // 2021-11-26T06:14:00Z should equal Fri Nov 26 2021 11:59:00 GMT+0545 (Nepal Time);
  return data.find((d) => d.active && new Date(appendUtcTimeZone(d.ending)).getTime() > new Date().getTime());
};


export const getProductsBySearchKeyword = ({
                                             keyword,
                                             page,
                                             pagination = true,
                                             itemPerPage = ITEM_PER_PAGE,
                                             filterBy,
                                             skipFilter = true,
                                           }) => {


  const queryParams = {
    search: keyword,
    item_per_page: itemPerPage,
    page: page ?? 1,
    pagination,
    // ...(isBriefSearch && {
    //   brief_search: true,
    // }),
    ...(skipFilter && {
      filter: false,
    }),
  }


  // if (filterBy?.length) {
  //   filterBy.forEach((f) => {
  //     Object.assign(queryParams, { [f.type]: f.values.join(',') })
  //   })
  // }
  Object.keys(filterBy).forEach(key => {
    const value = filterBy[key]
    Object.assign(queryParams, { [key]: value })
  })

  return apiService.get(searchURL, { params: queryParams })
}

export const getFlashSaleProductList = (page = 1, id, brandId, itemPerPage = ITEM_PER_PAGE) => {
  const params = {
    page: page,
    pagination: true,
    item_per_page: itemPerPage,
    ...(brandId && {brand_id: brandId})
  };

  return apiService.get(URIS_D('flash_sale_products', id), {params});
};


export const getProductInfoById = (id) => {
  return apiService.get(URIS_D('product_info', id))
}

const URIS_D = (url, param1) => {
  return {
    flash_sale_products: `${URIS.flash_sales}/${param1}/products`,
    category_products: `/v1/categories/${param1}/products`,
    product_campaign: `/v1/products/product-campaign/${param1}/products`,
    product_info: `/v1/products/${param1}`
  }[url];
};

const URIS = {
  hot_sales: '/v1/hot-sales',
  fresh_sales: '/v1/fresh-sales',
  flash_sales: '/v1/flash-sales',
  featured: '/v1/products/featured',
  products: "/v1/products"
};
